var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1720,
    height: 611,
    viewBox: "0 0 1720 611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2125",
    "data-name": "Rectangle 2125",
    width: 1720,
    height: 611,
    rx: 71,
    transform: "translate(100 3477)",
    fill: "#f0f0f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_2580",
    "data-name": "Groupe de masques 2580",
    transform: "translate(-100 -3477)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2999",
    "data-name": "Trac\\xE9 2999",
    d: "M-6527.527,11960.3c-193.2-66.693-421.41-232.855-399.4-469.617s305.8-110.622,137.054,192.835-272.273-608.163-789.908-492.1c-288.323,64.646-259.831,433.672-122.359,605.848,109.493,137.135,243.258,125.348,350.515,141.6,242.115,36.682,265.6-520.083-32.5-573.358s-487.036,272.676-385.739,809.383c41.533,220.055-116.823.035-205.906-208.439-82.11-192.158-191.144-371.263-301.759-354.886-154.021,29.523-111.926,309.638-170,354.886",
    transform: "translate(8447.527 -8049.632)",
    fill: "none",
    stroke: "#d0d0d0",
    strokeWidth: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.d858f1efc8277e42aa1ffc151047cc3c.svg";
export { ForwardRef as ReactComponent };